<script>
import { createEventDispatcher } from "svelte";
import WordTile from "./WordTile.svelte";

const dispatch = createEventDispatcher()

export let challengeWord = ''
export let guess = ''
export let status = ''
let letterStatus = []
let shake = false
$: {
  if (status === 'saved') {
    const guessLetters = guess.split('')
    const challengeLetters = challengeWord.split('')
    const matchIndexes = []
    const foundIndexes = []
    // exact matches first
    for (let idx = 0; idx < challengeWord.length; idx++) {
      if (guessLetters[idx] === challengeLetters[idx]) {
        dispatch('exact-match', guessLetters[idx])
        matchIndexes.push(idx)
        guessLetters.splice(idx, 1, '.')
        challengeLetters.splice(idx, 1, '.')
      }
    }
    // found matches next
    for (let idx = 0; idx < challengeWord.length; idx++) {
      if (challengeLetters.findIndex(l => l === guessLetters[idx]) !== -1) {
        dispatch('letter-found', guessLetters[idx])
        foundIndexes.push(idx)
        const removeIdx = challengeLetters.findIndex(l => l === guessLetters[idx])
        guessLetters.splice(idx, 1, '.')
        challengeLetters.splice(removeIdx, 1, '.')
      }
    }

    letterStatus = guessLetters.map((letter, letterIndex) => {
      if (letter !== '.') {
        const foundIndex = challengeLetters.findIndex(l => l === letter)
        const exactMatch = challengeLetters[letterIndex] === letter
        const notFound = (!exactMatch && foundIndex === -1 && status === 'saved')
        if (notFound) dispatch('not-found', letter)
      }
      return {
        exact: matchIndexes.includes(letterIndex),
        found: foundIndexes.includes(letterIndex),
        notFound: status === 'saved'
      }
    })
  } else if (status === 'checking') {
    const guessLetters = guess.split('')
    letterStatus = guessLetters.map(() => {
      return {
        checking: true
      }
    })
  } else if (status === 'fail') {
    shake = true
    setTimeout(() => {
      shake = false
    }, 2000);
  }
}
</script>

<div class={`flex items-center justify-center my-2${ shake ? ' shake' : '' }`}>
  <WordTile status={letterStatus[0]} letter={guess.charAt(0)} />
  <WordTile status={letterStatus[1]} letter={guess.charAt(1)} />
  <WordTile status={letterStatus[2]} letter={guess.charAt(2)} />
  <WordTile status={letterStatus[3]} letter={guess.charAt(3)} />
  <WordTile status={letterStatus[4]} letter={guess.charAt(4)} />
</div>

<style>
  .shake {
    animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
  }

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>